__webpack_require__.p = "/ai-tools/ai-resume-assistant/";